import { Icon, IconsEnum } from 'components/Icons';
import styles from './IppicaEmpty.module.scss';
export type IppicaEmptyProps = {
  iconId?: IconsEnum;
  hasMarginRight?: boolean;
  className?: string;
  children: React.ReactElement;
};

export const IppicaEmpty = ({ children, className, iconId, hasMarginRight }: IppicaEmptyProps) => {
  return (
    <div
      className={`${styles.container} ${className ? className : ''} ${hasMarginRight ? styles.withMarginRight : ''}`}
    >
      <Icon iconId={iconId ? IconsEnum[iconId] : IconsEnum.SEARCH_OFF} className={styles.icon} />
      <div className={styles.text}>{children}</div>
    </div>
  );
};
